<form [formGroup]="passwordForm">
    <div class="modal-header">
        <h4 class="modal-title" i18n>Set password</h4>
        <button type="button" class="btn-close" aria-label="Close"
            (click)="activeModal.close()"></button>
    </div>
    <div class="modal-body">
        <div class="row g-3">
            <div class="col-md-12">
                <label for="start" class="form-label" i18n>Password</label>
                <div class="input-group">
                    <input #password type="password" class="form-control" formControlName="password">
                    <button type="button" class="btn btn-secondary" (click)="password.type = password.type == 'password' ? 'text' : 'password'"><fa-icon [icon]="password.type == 'password' ? fa.faEye : fa.faEyeSlash"></fa-icon></button>
                </div>
            </div>
            <div class="col-md-12">
                <label for="password-email" class="form-label"><input type="checkbox" formControlName="email" class="form-check-input" id="password-email">&nbsp;<span i18n>Email password to user</span></label>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="activeModal.close()" i18n>Close</button>
        <button type="submit" class="btn btn-primary" (click)="setPassword()" i18n>Set password</button>
    </div>
</form>